export enum ServiceTypeEnum
    {
        EService = 1,
        ExternalService = 2,
        StaticService = 3,
        AutomatedOnly = 4,
    }